import { render } from "./ZijinHistory.vue?vue&type=template&id=6b192a8c&scoped=true"
import script from "./ZijinHistory.vue?vue&type=script&lang=js"
export * from "./ZijinHistory.vue?vue&type=script&lang=js"

import "./ZijinHistory.vue?vue&type=style&index=0&id=6b192a8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b192a8c"]])

export default __exports__